import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { config } from '../../config/config';
import { CgpApiService } from '../cgp-api';
import { getEnv } from '../utility';
import { BaseHttpService } from 'src/app/shared/base-http/base-http.service';

@Injectable()
export class TprecmApiService {
   constructor(
      private cgpApiService: CgpApiService,
      private readonly baseHttpService: BaseHttpService
   ) { }

   goToLandingPage() {
      window.location.href = '#/tprecm';
   }

   getActivePrograms() {
      return this.get('home/criteria/program');

   }

   getTprPrograms() {
      return this.get('tpr/criteria/program-name');
   }

   getEngineers() {
      return this.baseGet('tpr/criteria/mse');
   }

   getProgramMSE() {
      return this.baseGet('maint/criteria/program-mse');
   }

   getPartNoLHList() {
      return this.get('home/criteria/part-no-lh');
   }

   getCspcLHList() {
      return this.get('home/criteria/cspc-lh');
   }

   getGageNoList() {
      return this.get('home/criteria/gage-no');
   }

   getConstEngineers() {
      return this.get('home/criteria/cf-engineer');
   }

   getDesignSourceReps() {
      return this.get('home/criteria/design-src-rep');
   }

   getPartNoRHList() {
      return this.get('home/criteria/part-no-rh');
   }

   getCspcRHList() {
      return this.get('home/criteria/cspc-rh');
   }

   getFixtureTypes() {
      return this.get('home/criteria/fixture');
   }

   getFirstUserSources() {
      return this.get('home/criteria/first-user-source-name');
   }

   getDesignSources() {
      return this.get('home/criteria/des-source');
   }

   getUserSources() {
      return this.get('home/criteria/usr-source');
   }

   getBuildSources() {
      return this.get('home/criteria/build-source');
   }

   getSpan() {
      return this.get('tpr/criteria/span');
   }

   private get(path) {
      return this.cgpApiService
         .get(config.tprecmApiBaseUrl[getEnv()] + path, null)
   }

   private baseGet(path) {
      const url = `${config.tprecmApiBaseUrl[getEnv()]}${path}`;
      return this.baseHttpService.get(url);
   }
}
